import { NewTab, PageTab, PageTabAdv } from "../../../../components";
import { useModuleAccess } from "../../../../hooks";
import { getItem } from "../../../../utils/localStorageUtils";
import Security from "./AccessControlTabs/Security";
import UserTeams from "./AccessControlTabs/UserTeams";

const AccessControl = () => {
  const portal = getItem("portal");
  const DashboardMenus = [
    {
      title: "User Teams",
      page: <UserTeams />,
      type: "main",
      id: "settings_accesscontrol_userteams",
    },
    {
      title: "Security",
      page: <Security />,
      type: "main",
      id: "settings_accesscontrol_security",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: DashboardMenus,
    parentId: "settings_accesscontrol",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });

  return (
    <div className="mt-4 overflow-hidden flex flex-1">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="access-control"
      />
    </div>
  );
};

export default AccessControl;
